<div class="input-container">
  <mat-form-field appearance="legacy" floatLabel="never" class="input-text">
    <input *ngIf="mask && !decimal" [appFocus]="requestFocus" [name]="name" [readonly]="readOnly"
      [appNumericKeyboard]="numericKeyboard" [appTrim]="doTrim" [class.uppercase-input]="isAlfanumerico" matInput
      [placeholder]="placeholder" [mask]="mask" autocomplete="off" [formControl]="currentFormControl">
    <input *ngIf="!mask && !decimal" (keypress)="keyPressFilter($event)" [appFocus]="requestFocus" [name]="name"
      [readonly]="readOnly" [appNumericKeyboard]="numericKeyboard" [appTrim]="doTrim" matInput
      [placeholder]="placeholder" autocomplete="off" [formControl]="currentFormControl">
    <input *ngIf="decimal" [appFocus]="requestFocus" [name]="name" [readonly]="readOnly"
      [appNumericKeyboard]="numericKeyboard" [appTrim]="doTrim" matInput [placeholder]="placeholder" autocomplete="off"
      [formControl]="currentFormControl" currencyMask
      [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
    <ng-container *ngIf=isCepLoading matSuffix>
      <mat-spinner diameter="25"></mat-spinner>
    </ng-container>
    <mat-error *ngIf="isInvalid()">{{getErrorMessage()}}</mat-error>
  </mat-form-field>
</div>